import { Spinner } from '@augmentt-dev/ui-components'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { Modal } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'

const propTypes = {
  /**
   * Modal content
   */
  children: PropTypes.node,
  /**
   * If true, show loading indicator instead of content
   */
  isLoading: PropTypes.bool,
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
  /**
   * Description to display when loading. FormattedMessage id
   */
  loadingDescription: PropTypes.string,
}

function ModalBody(props) {
  const { isLoading = false, children = null, className = '', loadingDescription = null } = props ?? {}

  return (
    <Modal.Body className={clsx('modal-body-sidebar unstyled-modal text-color-default', className)}>
      {/* General Loading Spinner */}
      {isLoading ? (
        <div className="modal-loading-centered">
          <Spinner />
          {loadingDescription && (
            <div className="mt-4 text-strong text-color-secondary">
              <FormattedMessage id={loadingDescription} />
            </div>
          )}
        </div>
      ) : (
        children
      )}
    </Modal.Body>
  )
}

ModalBody.propTypes = propTypes

export default ModalBody
